import { Modal } from "antd";
import { observer } from "mobx-react-lite";
import * as React from "react";
import { extensionsByScopeLoader } from "src/business/extensions/apiExtensions";
import {
  ExtensionsFilter,
  ZExtension,
  ZExtensionScope,
} from "src/business/extensions/ZExtension";
import { MdmTable } from "src/components/MdmTable";
import { RtSelection } from "src/components/ReactiveTable/components/RtSelection";
import { RtStore } from "src/components/ReactiveTable/RtStore";
import { ToolBox2 } from "src/components/ToolBox2";
import { createExtensionColumns } from "src/pages/management/extensions/ExtensionsPage/createExtensionColumns";

type PropsExtensionSelectModal = {
  scope: ZExtensionScope;
  close(): void;
  onSelect(extension: ZExtension): void;
};

export const ExtensionSelectModal: React.FC<PropsExtensionSelectModal> =
  observer((props) => {
    const { scope, close, onSelect } = props;
    const store = React.useMemo(
      () =>
        new RtStore<ZExtension, ExtensionsFilter>({
          rowKey: "id",
          loader: extensionsByScopeLoader(scope),
          selectionType: "radio",
        }),
      [scope],
    );
    const columns = React.useMemo(() => createExtensionColumns(), []);

    return (
      <Modal
        open
        onCancel={close}
        title="Выбор расширения"
        centered
        okText="Выбрать"
        okButtonProps={{ disabled: !store.selectedKeys.length }}
        onOk={() => {
          const extension = store.selectedRows[0];
          if (extension) {
            onSelect(extension);
          }
        }}
        width="calc(100vw - 160px)"
        styles={{
          body: {
            height: "calc(100vh - 200px)",
          },
        }}
      >
        <ToolBox2
          mainTool={
            <RtSelection
              store={store}
              makeOption={(key, row) => ({
                value: key,
                label: row?.name || key,
              })}
            />
          }
        >
          <MdmTable
            store={store}
            columns={columns}
            showTotal={(count) => `Всего: ${count}`}
            resizableColumns
          />
        </ToolBox2>
      </Modal>
    );
  });
